import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import { HierarchyProperties } from "./HierarchyProperties";
const table = "11111111-1111-4111-8111-111111111111";
const mockData = {
  views: {
    people: {
      focus_table_id: table,
      fields: [
        { column_id: "id", is_visible: true },
        { column_id: "name", is_visible: true },
        { column_id: "manager", is_visible: true },
      ],
      joins: [],
    },
  },
  tables: [
    {
      id: table,
      columns: [
        { id: "id", table_id: table, column_name: "id", is_primary_key: true },
        { id: "name", table_id: table, column_name: "name" },
        { id: "manager", table_id: table, column_name: "manager" },
      ],
    },
  ],
  relationships: [
    {
      id: "22222222-2222-4222-8222-222222222222",
      relationship_name: "reports to",
      from_table_id: table,
      from_column_id: "manager",
      to_table_id: table,
      to_column_id: "id",
    },
  ],
  loading: false,
  error: null,
};
jest.mock("../../../hooks/useHierarchyBuilderData", () => ({
  useHierarchyBuilderData: () => mockData,
}));
const sources = [{ id: "people", name: "People", view_id: "view" }] as any;
function Builder() {
  const [props, setProps] = React.useState({});
  return (
    <HierarchyProperties
      props={props}
      dataSources={sources}
      onChange={(value) => setProps((old) => ({ ...old, ...value }))}
    />
  );
}
test("builder selects ordinary View rows and an existing relationship with independent layout", () => {
  render(<Builder />);
  fireEvent.click(screen.getByRole("button", { name: "Add item View" }));
  expect(screen.getByLabelText("Item 1 key")).toHaveValue("id");
  fireEvent.change(screen.getByLabelText("Existing relationship"), {
    target: { value: "0" },
  });
  fireEvent.click(screen.getByRole("button", { name: "Add relationship" }));
  expect(screen.getByLabelText("Reverse relationship 1")).not.toBeChecked();
  fireEvent.click(screen.getByLabelText("Reverse relationship 1"));
  fireEvent.change(screen.getByLabelText("Layout"), {
    target: { value: "radial" },
  });
  expect(screen.getByLabelText("Layout")).toHaveValue("radial");
  expect(screen.getByLabelText("Reverse relationship 1")).toBeChecked();
  expect(screen.queryByText("Allow editing")).not.toBeInTheDocument();
});
test("removing an item removes its relationship mappings instead of leaving an invalid endpoint", () => {
  render(<Builder />);
  fireEvent.click(screen.getByRole("button", { name: "Add item View" }));
  fireEvent.change(screen.getByLabelText("Existing relationship"), {
    target: { value: "0" },
  });
  fireEvent.click(screen.getByRole("button", { name: "Add relationship" }));
  fireEvent.click(screen.getByRole("button", { name: "Remove item 1" }));
  expect(
    screen.queryByLabelText("Reverse relationship 1"),
  ).not.toBeInTheDocument();
});

const originalData = JSON.parse(JSON.stringify(mockData));
afterEach(() =>
  Object.assign(mockData, JSON.parse(JSON.stringify(originalData))),
);
test("a link View binds two existing endpoint relations, not new graph storage", () => {
  const linkTable = "33333333-3333-4333-8333-333333333333";
  const extra = mockData as any;
  extra.tables.push({
    id: linkTable,
    columns: [
      { id: "from", table_id: linkTable, column_name: "from_id" },
      { id: "to", table_id: linkTable, column_name: "to_id" },
      { id: "kind", table_id: linkTable, column_name: "kind" },
    ],
  });
  extra.views.links = {
    focus_table_id: linkTable,
    joins: [],
    fields: ["from", "to", "kind"].map((id) => ({
      column_id: id,
      is_visible: true,
    })),
  };
  extra.relationships.push(
    {
      id: "44444444-4444-4444-8444-444444444444",
      relationship_name: "source",
      from_table_id: linkTable,
      from_column_id: "from",
      to_table_id: table,
      to_column_id: "id",
    },
    {
      id: "55555555-5555-4555-8555-555555555555",
      relationship_name: "target",
      from_table_id: linkTable,
      from_column_id: "to",
      to_table_id: table,
      to_column_id: "id",
    },
  );
  const change = jest.fn();
  render(
    <HierarchyProperties
      props={{
        hierarchy_config: {
          nodes: [
            {
              data_source_alias: "people",
              table_id: table,
              id_field: "id",
              label_field: "name",
            },
          ],
          relationships: [],
          layout: "tree",
        },
      }}
      dataSources={[
        ...sources,
        { id: "links", name: "Links", view_id: "links-view" },
      ]}
      onChange={change}
    />,
  );
  const option = screen.getByRole("option", {
    name: "Links: source → target",
  }) as HTMLOptionElement;
  fireEvent.change(screen.getByLabelText("Existing relationship"), {
    target: { value: option.value },
  });
  fireEvent.click(screen.getByRole("button", { name: "Add relationship" }));
  expect(change).toHaveBeenLastCalledWith({
    hierarchy_config: expect.objectContaining({
      relationships: [
        expect.objectContaining({
          relationship_ids: [
            "44444444-4444-4444-8444-444444444444",
            "55555555-5555-4555-8555-555555555555",
          ],
          link_data_source_alias: "links",
          from_field: "from_id",
          to_field: "to_id",
        }),
      ],
    }),
  });
});
